module.exports = __webpack_public_path__ + "img/treatment-with-questionnaire-icon.76144329.svg";